import React from "react";
import PropTypes from "prop-types";

export const AssignContent = ({ id }) => {
  return <span>{id}</span>;
};

AssignContent.propTypes = {
  id: PropTypes.number,
};

AssignContent.defaultProps = {
  id: 1,
};
